import { Component, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, Observable, Subscription } from 'rxjs';
import { IImport, IImportFilter, IImportFilterRequest } from '../../models/imports.models';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { GetImports, SetImportFilter, SetImportLoader } from '../../store/imports.actions';
import { DATE_TIME_FORMAT, DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'src/app/config/global.config';
import { ImportProductsService } from '../../services/imports.services';
import { IPageCount, IPagination } from 'src/app/shared/models/page.model';
import { encodeFilterObject, parseFilterRequest, parseImportFilterRequest, refillFilter } from 'src/app/shared/utils/helpers';
import { ImportComponent } from '../import/import.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-imports',
  templateUrl: './list-imports.component.html',
  styleUrls: ['./list-imports.component.scss']
})
export class ListImportsComponent implements OnInit {
  expandedIndex: number = -1;
  page: IPageCount = {
    size: DEFAULT_PAGE_SIZE,
    number: 1
  }
  DATE_FORMAT = DATE_TIME_FORMAT;

  placeholder: string = 'assets/images/placeholder.png';
  imports$: Observable<IImport[]> = this.store.select((state)=> state.importProducts.imports);
  isAppLoading$ = this.store.select((state) => state.shared.isAppLoading);
  filter: IImportFilterRequest | undefined = undefined
  key: string | undefined = undefined
  pagination$: Observable<IPagination | null> = this.store.select((state) => state.importProducts.metadata);
  private subscriptions: Subscription[] = [];
  unparsedFilter:IImportFilter | null = null;
  module:string = 'import';

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private services: ImportProductsService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      const pageNumber = parseInt(params['page'] || '1');
      const pageCount = PAGE_SIZE_OPTIONS.includes(parseInt(params['count'])) ? parseInt(params['count']) : DEFAULT_PAGE_SIZE;
      this.key = params['keyword'] ?? '';
      if(params['filter'])
      {
        try {
          this.unparsedFilter = refillFilter(this.module, JSON.parse(decodeURIComponent(params['filter']))) as IImportFilter
          if(this.unparsedFilter)
            this.filter = parseFilterRequest(this.module, this.unparsedFilter);
        } catch (error) {
          this.filter == undefined
        }
      }
      this.page = { ...this.page, number: pageNumber, size: pageCount };
    });
   }

  ngOnInit(): void {
    const sub1 = this.store.select((state) => state.importProducts.ImportFilterState)
    .pipe(
      debounceTime(10),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
    )
    .subscribe((filter) => {
      this.unparsedFilter = filter.advanced;
      this.filter = parseFilterRequest(this.module, filter.advanced);
      this.key = filter.keyword;
      this.toPage(this.page);
    });

    this.subscriptions.push(sub1);
  }

  import() {
    this.dialog.open(ImportComponent, {
      disableClose: true,
      width: '35vw',
      minWidth: '600px'
    })
  }

  details(id: number, validated: boolean) {
    if(!validated) return
    let filter:any = {}
    if(this.key && this.key != ''){
      filter.keyword = this.key;
    }
    filter.filter = encodeFilterObject(this.unparsedFilter);
    let queryParams = { page: this.page.number, count: this.page.size, ...filter };
    this.router.navigate(['imports/', id],{
      queryParams: queryParams,
    });
  }
  toPage(page: IPageCount) {
    this.page = { ...this.page, number: page.number, size: page.size };
    this.store.dispatch(GetImports({ page: page, filter: this.filter, key: this.key }));
    let filter:any = {}
    if(this.key && this.key != ''){
      filter.keyword = this.key;
    }
    filter.filter = encodeFilterObject(this.unparsedFilter);
    let queryParams = { page: this.page.number, count: this.page.size, ...filter };
    this.router.navigate([], {
      queryParams: queryParams
    });
  }
  downloadFile(imported: IImport) {
    this.store.dispatch(SetImportLoader({ isLoading: true }));
    this.services.getFileImported(imported.id).subscribe({
      next: (res: {data: [], object: {file: string}}) => {
        this.store.dispatch(SetImportLoader({ isLoading: false }));
        const byteCharacters = atob(res?.object?.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: (err) => {
        this.store.dispatch(SetImportLoader({ isLoading: false }));
      }
    });
  }

  ngOnDestroy(): void{
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
